import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurchaseOrderThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 66,
	height: 81,
	viewBox: "0 0 66 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6311_40932)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M56.6208 3H9.37838C8.06484 3 7 4.06296 7 5.37419V67.7259C7 69.0371 8.06484 70.1001 9.37838 70.1001H56.6208C57.9344 70.1001 58.9992 69.0371 58.9992 67.7259V5.37419C58.9992 4.06296 57.9344 3 56.6208 3Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M56.6209 3.14844H9.37841C8.14697 3.14844 7.14868 4.14497 7.14868 5.37424V67.7259C7.14868 68.9552 8.14697 69.9517 9.37841 69.9517H56.6209C57.8523 69.9517 58.8506 68.9552 58.8506 67.7259V5.37424C58.8506 4.14497 57.8523 3.14844 56.6209 3.14844Z",
				stroke: "#D0D5DD",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 10.9097,
			width: 16,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 10.9097,
			width: 16,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 14.9097,
			width: 30,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 18.9097,
			width: 40,
			height: 3,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 24.9097,
			width: 5,
			height: 32,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.973,
			y: 24.9097,
			width: 22,
			height: 32,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 43.973,
			y: 24.9097,
			width: 9,
			height: 32,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.973,
			y: 59.9097,
			width: 40,
			height: 1,
			rx: .5,
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6311_40932",
			x: .898682,
			y: .898438,
			width: 64.2019,
			height: 79.3032,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_40932"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_40932",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgPurchaseOrderThumbnail;
